<template>
    <div>
        <JsonLd :json="jsonld" />
        <main id="special211101">
            <!-- 特集Specialコンテンツここから-->

            <!-- Luxury Destinations ここから -->
            <section class="luxries">

                <div class="breadcrumb">
                    <ul>
                        <li>
                            <router-link :to="{name: 'Index'}">TOP</router-link>
                        </li>
                        <li>Luxury</li>
                    </ul>
                </div>

                <div class="luxuryTagWrapper fadeIn">
                    <img src="../../assets/luxury_travel/luxury_travel03/svg/luxury_destinations.svg" class="luxury_tag" alt="Past Articles">
                </div><!-- luxuryTagWrapper -->

                <div class="luxury__title_wrapper">
                    <h2 class="luxury__title fadeIn">Luxury Destinations</h2>
                </div><!-- luxury__title_wrapper -->

                <div class="luxuryBoxArea">

                    <div class="luxuryBox left luxuryBox01">
                        <div class="luxuryBox__image">
                            <img src="../../assets/luxury_travel/index/luxury_dammy.png" class="luxury_dammy" alt="">
                            <img src="../../assets/luxury_travel/index/luxury01.jpg" class="luxuryBox__image__inner01 luxuryBox__image__inner" alt="">
                            <div class="luxury__colormat colormat01"></div><!-- luxury__colormat -->
                        </div><!-- luxuryBox__image -->
                        <div class="luxuryBox__text fadeIn">
                            <router-link :to="{name: 'LuxuryTravel01'}" class="luxuryBox__title">Explore the Spiritual Mountains of Muro</router-link>
                            <p class="luxuryBox__des">Deep in rural Nara prefecture, among the valleys and peaks of the Kii mountain range, lie hidden temples, shrines and sacred sites with histories stretching far back in to Japan’s past. Far from the big cities of Tokyo and Osaka, this region offers a glimpse into the spiritual underpinnings of Japan’s unique religious culture.</p>
                            <router-link :to="{name: 'LuxuryTravel01'}" class="luxuryBox__link">Read the article</router-link>
                        </div><!-- luxuryBox__text -->
                    </div><!-- luxuryBox -->

                    <div class="luxuryBox right luxuryBox02">
                        <div class="luxuryBox__image">
                            <img src="../../assets/luxury_travel/index/luxury_dammy.png" class="luxury_dammy" alt="">
                            <img src="../../assets/luxury_travel/index/luxury02.jpg" class="luxuryBox__image__inner02 luxuryBox__image__inner" alt="">
                            <div class="luxury__colormat colormat02"></div><!-- luxury__colormat -->
                        </div><!-- luxuryBox__image -->
                        <div class="luxuryBox__text fadeIn">
                            <router-link :to="{name: 'LuxuryTravel02'}" class="luxuryBox__title">Nakasendo: The Path to a Bygone Era</router-link>
                            <p class="luxuryBox__des">An ancient path cuts through the picturesque countryside of Nagano Prefecture. It’s the Nakasendo, a centuries-old mountain road that has been traveled by scores of samurai, monks, peasants, and even an emperor. Along this path, discover local shops, hidden shrines, and breathtaking views.</p>
                            <router-link :to="{name: 'LuxuryTravel02'}" class="luxuryBox__link">Read the article</router-link>
                        </div><!-- luxuryBox__text -->
                    </div><!-- luxuryBox -->

                    <div class="luxuryBox left luxuryBox03">
                        <div class="luxuryBox__image">
                            <img src="../../assets/luxury_travel/index/luxury_dammy.png" class="luxury_dammy" alt="">
                            <img src="../../assets/luxury_travel/index/luxury03.jpg" class="luxuryBox__image__inner03 luxuryBox__image__inner" alt="">
                            <div class="luxury__colormat colormat03"></div><!-- luxury__colormat -->
                        </div><!-- luxuryBox__image -->
                        <div class="luxuryBox__text fadeIn">
                            <router-link :to="{name: 'LuxuryTravel03'}" class="luxuryBox__title">Where Land Meets Sea, Discover the Heritage of Ama Divers</router-link>
                            <p class="luxuryBox__des">Hidden on the fringes of the Kii peninsula, the Ise-Shima area is riven with coastal bays and inlets, intrusions of the Pacific into the land. The blue waters of Ago Bay aren’t just a scenic backdrop, though; they are home to some of Japan’s most delicious seafood, such as the spiny Ise ebi lobster.</p>
                            <router-link :to="{name: 'LuxuryTravel03'}" class="luxuryBox__link">Read the article</router-link>
                        </div><!-- luxuryBox__text -->
                    </div><!-- luxuryBox -->

                    <div class="luxuryBox right luxuryBox04">
                        <div class="luxuryBox__image">
                            <img src="../../assets/luxury_travel/index/luxury_dammy.png" class="luxury_dammy" alt="">
                            <img src="../../assets/luxury_travel/index/luxury04.jpg" class="luxuryBox__image__inner04 luxuryBox__image__inner" alt="">
                            <div class="luxury__colormat colormat04"></div><!-- luxury__colormat -->
                        </div><!-- luxuryBox__image -->
                        <div class="luxuryBox__text fadeIn">
                            <router-link :to="{name: 'LuxuryTravel04'}" class="luxuryBox__title">Dewa: Monks, Merchants, and Mountain Ascetics</router-link>
                            <p class="luxuryBox__des">The Yamagata region blends the stunning natural scenery of the mountains with a rich religious heritage, such as can be seen at Yamadera Temple, founded in 860 CE by the monk Ennin.</p>
                            <router-link :to="{name: 'LuxuryTravel04'}" class="luxuryBox__link">Read the article</router-link>
                        </div><!-- luxuryBox__text -->
                    </div><!-- luxuryBox -->

                    <div class="luxuryBox left luxuryBox05">
                        <div class="luxuryBox__image">
                            <img src="../../assets/luxury_travel/index/luxury_dammy.png" class="luxury_dammy" alt="">
                            <img src="../../assets/luxury_travel/index/luxury05.jpg" class="luxuryBox__image__inner05 luxuryBox__image__inner" alt="">
                            <div class="luxury__colormat colormat05"></div><!-- luxury__colormat -->
                        </div><!-- luxuryBox__image -->
                        <div class="luxuryBox__text fadeIn">
                            <router-link :to="{name: 'LuxuryTravel05'}" class="luxuryBox__title">Colors of Tradition: The Red Crafts of Okayama</router-link>
                            <p class="luxuryBox__des"></p>
                            <router-link :to="{name: 'LuxuryTravel05'}" class="luxuryBox__link">Read the article</router-link>
                        </div><!-- luxuryBox__text -->
                    </div><!-- luxuryBox -->

                    <div class="luxuryBox right luxuryBox06">
                        <div class="luxuryBox__image">
                            <img src="../../assets/luxury_travel/index/luxury_dammy.png" class="luxury_dammy" alt="">
                            <img src="../../assets/luxury_travel/index/luxury06.jpg" class="luxuryBox__image__inner06 luxuryBox__image__inner" alt="">
                            <div class="luxury__colormat colormat06"></div><!-- luxury__colormat -->
                        </div><!-- luxuryBox__image -->
                        <div class="luxuryBox__text fadeIn">
                            <router-link :to="{name: 'LuxuryTravel06'}" class="luxuryBox__title">Forged in Time: Uncovering Okuizumo's Steel Heritage</router-link>
                            <p class="luxuryBox__des">In Japan, Shimane is a region synonymous with mythology; its landmarks like Inasa no Hama Beach and Izumo Taisha Shrine are proud symbols of Japan’s spiritual legacy.</p>
                            <router-link :to="{name: 'LuxuryTravel06'}" class="luxuryBox__link">Read the article</router-link>
                        </div><!-- luxuryBox__text -->
                    </div><!-- luxuryBox -->

                </div><!-- luxuryBoxArea -->

            </section>
            <!-- Luxury Destinations ここまで -->

            <!-- 特集Specialコンテンツここまで-->
            <streaks-player ref="streaks"></streaks-player>
        </main>
    </div>
</template>

<script>
import StreaksPlayer from "@/components/StreaksPlayer/StreaksPlayer";
import ApiRouter from "@/components/Systems/ApiRouter";
import 'video.js/dist/video-js.css';
import JsonLd from "@/components/JsonLd/JsonLd.vue";

export default {
    name: "LuxuryTravel",
    components: {JsonLd, StreaksPlayer},
    mixins: [ApiRouter],
    data: function () {
        return {
            publicPath: `${process.env.VUE_APP_PUBLIC_PATH}`,
            categoryId: '09788e7d-5beb-4d3b-b644-32d3a36f4755',
            keywords: ['temple&shrine', 'historic building', 'Buddha statue', 'food culture', 'religion', 'mountain'],
            relatedArticles: [],
            nearByArticles: [],
            videoOptions: {
                autoplay: 'true',
                controls: false,
                preload: 'none',
                fluid: true,
                loop: true,
                muted: true,
                sources: [
                    {
                        src:
                            `${process.env.VUE_APP_VIDEO_URL}` + "/streaks/luxurytravel/luxurytravel02/bg_main.m3u8",
                    }
                ],
            },
            jsonld: {
                "@context": "https://schema.org",
                "@graph": [
                    {
                        "@type": "Article",
                        "mainEntityOfPage": window.location.href,
                        "headline": 'Luxury Destinations',
                        "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                            "and other cultural assets. Find photos, videos, tourist information, and more.",
                        "image": [
                            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAABgCAYAAAC0TppOAAAABHNCSVQICAgIfAhkiAAAAd5JREFUeF7d3DtOAzEUBVB7SeyCFRBRAQWp0dDQkY6K9NNS8VkAu2NgEinRkPn48z735laWKx+9xnqyX/xqm4efGC6u7re3MYYuECZ+tM0mxvjche5ttd7eEBpC7A/92T6+/K2eWCE7BDvkgGCGDBCskBMEI2QUwQaZRDBBZhEskEUEAyQJgQ5JRiBDshCokGwEIqQIgQYpRiBBqhAokGoEAkQE4Q0RQ3hCRBFeEHGEB0QFYQ1RQ1hCVBFWEHWEBcQEoQ0xQ2hCTBFaEHOEBsQFIQ1xQ0hCXBFSEHeEBAQCUQuBQdRAoBBDSHhfrV+v+72lwCFKIJCIXAgsIgcCjUiFwCNSIBSIJQgNYg5ChZiC0CHGIJSIPaT5DjFehtDdUSKOr4L2VxM6xH9AXxUqxBiACjEFoEHMASgQSwB4RAoAGpEKgEXkACARuQA4RAkAClEKgEHUACAQtQB3hATAFSEFcENIAlwQ0gBzhAbAFKEFMENoAkwQ2gB1hAVAFWH52Uql22EJUKmENUAc4QEQRXgBxBCeABGEN6AagQCoQqAAihFIgCIEGiAbgQjIQqACkhHIgCQEOmARwQCYRbAAJhFMgFEEG+AEwQgYIFgBBwQzYIc4i1k2ZzFVqC8He34BnstzlSi4Q8IAAAAASUVORK5CYII="
                        ],
                        "datePublished": "2020/04/14",
                        "dateModified": "2024/11/14",
                        "author": [{
                            "@type": "Organization",
                            "name": "Japan National Tourism Organization",
                            "url": "https://www.japan.travel/japan-heritage/"
                        }]
                    },
                    {
                        "@type": "BreadcrumbList",
                        "itemListElement":  [{
                            "@type": "ListItem",
                            "position": 1,
                            "name": "TOP",
                            "item": "https://www.japan.travel/japan-heritage/"
                        },{
                            "@type": "ListItem",
                            "position": 2,
                            "name": "'Luxury Destinations",
                            "item": "https://www.japan.travel/japan-heritage/luxurytravel"
                        }]
                    }
                ]
            }
        }
    },
    created: function () {
        this.searchRelatedArticles();
        this.searchNearByArticles();
        document.title = 'Japan Heritage Official Site | Stories and travel information | JNTO'
    },
    mounted: function () {
        let url = this.publicPath + 'js/luxurytravel.js';
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', url);
        document.head.appendChild(recaptchaScript);
    },
    methods: {
        openStreaksPlayer: function (id) {
            this.$refs.streaks.open(id);
        },
        searchRelatedArticles: function () {
            const keyword = this.keywords[Math.floor(Math.random() * this.keywords.length)];
            window.axios.get(this.routes.articles, {
                params: {
                    keyword: keyword,
                    story: true,
                }
            })
                .then((response) => {
                    this.relatedArticles = response.data.data;
                });
        },
        searchNearByArticles: function () {
            window.axios.get(this.routes.articles, {
                params: {
                    category_id: this.categoryId,
                    story: true,
                }
            })
                .then((response) => {
                    this.nearByArticles = response.data.data;
                });
        },
        goToStoryPage: function (id) {
            this.$router.push({name: 'Popular', params: {id: id, page: 'about'}});
        },
    }
}
</script>

<style src="./LuxuryTravel.scss" lang="scss" scoped/>
